import { Kbd } from './Kbd';
import { cn } from './cn';
import { useAltHeld } from './useAltHeld';

/*
  ActionKey — клавиша действия, которая появляется только пока удерживается Alt (DESIGN.md R33).
  Пока Alt не нажат, кнопка выглядит обычной: подсказки не засоряют экран на каждый день.
*/

export function ActionKey({ combo, className }: { combo: string; className?: string }) {
  const visible = useAltHeld();
  if (!visible) return null;
  return <Kbd className={cn('animate-fade-in', className)}>{combo}</Kbd>;
}
